// extracted by mini-css-extract-plugin
module.exports = {"v-application":"CatalogCartBtn_v-application_2F0hF","text-h1":"CatalogCartBtn_text-h1_1u6Tl","text-h2":"CatalogCartBtn_text-h2_10LtX","btn":"CatalogCartBtn_btn_2eSxV"};